import { forwardRef, type HTMLAttributes, type PropsWithChildren } from "react";

export const Card = forwardRef<
  HTMLDivElement,
  PropsWithChildren<HTMLAttributes<HTMLDivElement>>
>(function Card({ className = "", ...props }, ref) {
  return (
    <div
      ref={ref}
      className={`liquid-glass rounded-[22px] border border-white/[.09] ${className}`}
      {...props}
    />
  );
});
